<!-- eslint-disable prettier/prettier -->
<template>
  <div class="text-center">
    <edit-campaign-model
      :is-active.sync="isEditting"
      method="put"
      :campaign="campaign"
      @edited="campaignEdited"
    />
    <v-menu
      v-model="menu"
      :nudge-width="200"
      offset-x
      :close-on-content-click="false"
      :close-on-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="success"
          @click="setDefault()"
          :disabled="campaign.is_the_default == true"
          class="ml-2"
        >
          <v-icon>mdi-default</v-icon>
          Set Default
        </v-btn>
        <v-btn
          color="primary"
          @click="reopen()"
          v-if="campaign.has_expired == true"
          :disabled="campaign.has_expired == false"
          class="ml-2"
        >
          <v-icon>mdi-refresh</v-icon>
          Reopen
        </v-btn>
        <v-btn
          color="primary"
          @click="cancel()"
          v-if="campaign.has_expired == false"
          :disabled="campaign.has_expired == true"
          class="ml-2"
        >
          <v-icon>mdi-cancel</v-icon>
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          @click="publish()"
          :disabled="campaign.published_at != null || campaign.has_expired ==  true"
          class="ml-2"
        >
          <v-icon>mdi-publish</v-icon>
          Publish
        </v-btn>
        <v-btn color="primary" v-on="on">
          <v-icon>mdi-pencil-outline</v-icon>
          Campaign
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon size="60">mdi-truck</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>{{ campaign.name }}</v-list-item-title>
              <!-- <v-list-item-subtitle>{{ campaignType }}</v-list-item-subtitle> -->
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="menu = false">
                <v-icon size="40">mdi-close-circle-outline</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <!-- <v-list-item>
            <v-list-item-action>
              <v-switch
                inset
                :loading="isActivating"
                :input-value="!!campaign.is_active"
                @change="toggleActivity"
                :disabled="isActivating"
                color="primary"
                ripple
              />
            </v-list-item-action>
            <v-list-item-title>Activate Campaign</v-list-item-title>
          </v-list-item> -->
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <!-- <v-spacer></v-spacer> -->
          <v-btn text @click="isEditting = true">
            <v-icon color="light-blue lighten-4">
              mdi-account-edit-outline
            </v-icon>
            Edit
          </v-btn>
          <v-btn text @click="destroy(true)">
            <v-icon color="light-blue lighten-4">mdi-delete-circle-outline</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import EditCampaignModel from "./campaignForm";

export default {
  components: { EditCampaignModel },
  props: {
    campaign: { required: true, type: Object },
    defaultCampaign: { type: Object },
  },
  data: () => ({
    menu: false,
    isEditting: false,
    isActivating: false,
    isRestoring: false,
  }),
  computed: {},
  methods: {
    toggleActivity() {
      const { id } = this.campaign;
      this.isActivating = true;
      this.$http
        .put(`api/v1/campaigns/${id}/activity`)
        .then(({ campaign }) => {
          this.$emit("update:campaign", campaign);
          Notify.success("Operation was success full");
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.isActivating = false));
    },
    campaignEdited({ campaign }) {
      this.isEditting = false;
      this.menu = false;
      this.$emit("update:campaign", campaign);
      Notify.success("Campaign was updated successfully");
    },
    restore() {
      this.isRestoring = true;
      this.$http
        .post(`api/v1/campaigns/restore/${this.campaign.id}`)
        .then(({ message }) => {
          Notify.success(message);
          this.$router.push({ name: "campaigns" });
        })
        .catch((error) => {
          Notify.errorFromResponse(error, { close: true });
        })
        .finally(() => (this.isRestoring = false));
    },
    publish() {
      const params = {};

      const title = "The campaign will be published";
      Notify.confirm(
        `${title}, All the campaign details will be sent to all the participants`,
      ).then(() => {
        this.$http
          .put(`/api/v1/campaigns/${this.campaign.id}/publish`, { params })
          .then(() => {
            Notify.success("Campaign was published successfully!");
            this.$router.push({ name: "campaigns" });
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
          });
      });
    },
    reopen() {
      const params = {};

      const title = "The campaign will be reopened";
      Notify.confirm(
        `${title}, This will extend the expiry date of this campaign by 1 week, you can edit the campaign later to manually change the expiry date, you will have to publish the campaign before it's usable by clients`,
      ).then(() => {
        this.$http
          .put(`/api/v1/campaigns/${this.campaign.id}/reopen `, { params })
          .then(() => {
            Notify.success("Campaign was reopened successfully!");
            this.$router.push({ name: "campaigns" });
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
          });
      });
    },
    cancel() {
      const params = {};

      const title = "The campaign will be cancelled";
      Notify.confirm(`${title}, All the campaign data will be hidden from the participants`).then(
        () => {
          this.$http
            .put(`/api/v1/campaigns/${this.campaign.id}/close `, { params })
            .then(() => {
              Notify.success("Campaign was cancelled successfully!");
              this.$router.push({ name: "campaigns" });
            })
            .catch((error) => {
              Notify.errorFromResponse(error, { close: true });
            });
        },
      );
    },
    setDefault() {
      const title =
        this.defaultCampaign === undefined
          ? "Currently, there isn't a default campaign."
          : `Currently, the default campaign is "${this.defaultCampaign.name}""`;
      Notify.confirm(
        `${title}, Do you want to set the campaign "${this.campaign.name}" as the default campaign?`,
      ).then(() => {
        this.$http
          .put(`/api/v1/campaigns/${this.campaign.id}/setDefault`, {})
          .then((response) => {
            if (response.status === 204) {
              Notify.success(
                `Campaign ${this.campaign.name} was set as default campaign successfully!`,
              );
              this.$router.push({ name: "campaigns" });
            } else {
              Notify.error(`Unhandled response status code ${response.status}`, { close: true });
            }
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
          });
      });
    },
    destroy(permanent) {
      const params = {};
      if (permanent) {
        params.delete = true;
      }
      const title = permanent ? "This action is irreversible" : "The campaign will be archived";
      Notify.confirm(`${title}, All the campaign data will be lost`).then(() => {
        this.$http
          .delete(`/api/v1/campaigns/${this.campaign.id}`, { params })
          .then(() => {
            Notify.success("Campaign was deleted successfully!");
            this.$router.push({ name: "campaigns" });
          })
          .catch((error) => {
            Notify.errorFromResponse(error, { close: true });
          });
      });
    },
  },
};
</script>
